/**
 * FileRandomReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileRandomReq
 */
export interface FileRandomReq {
  /** 获取数量(1-100) */
  count: number
  /** 文件类型过滤(image/video/audio/document) */
  file_type?: string
}

/**
 * FileRandomReq Schema
 */
export const FileRandomReqSchema: SchemaDefinition = {
  properties: {
    count: {
      default: 10,
      description: '获取数量(1-100)',
      format: 'int',
      maximum: 100,
      minimum: 1,
      type: 'integer',
      label: '获取数量',
    },
    file_type: {
      description: '文件类型过滤(image/video/audio/document)',
      format: 'cons.FileType',
      type: 'string',
      label: '文件类型过滤',
    },
  },
  required: ['count'],
  type: 'object',
}
